// Dependencies
import React from 'react';
import { useEffect, useState } from 'react';

// App components
import ButtonFull from '../../global_components/buttons/ButtonFull';
import ButtonOutline from '../../global_components/buttons/ButtonOutline';

const LogoutPage = () => {
  const [loggedoutSuccess, setLoggedoutSuccess] = useState();
  const [statusMessage, setStatusMessage] = useState("");

  useEffect(() => {
    const logout = async () => {
      try {
        const response = await fetch("https://wad-backend.ws381566.remote.ac/logout.php?adminRequired=false", {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        });

        const result = await response.json();

        if(result.status === "authenticationError"){
          window.location.href = '/login';
        }

        if (result.status === "success") {
          setLoggedoutSuccess(true);
        } else {
          setLoggedoutSuccess(false);
          setStatusMessage(result.message || "Failed to execute query");
        }
      } catch (error) {
        setStatusMessage(error.message);
      }
    };

    logout();
  }, []);

  return (
    <div className='w-full h-full flex flex-col items-center bg-primary bg-[#161C33] px-7 sm:px-20 gap-5'>
      <div className='w-full flex flex-col gap-4 sm:flex-row items-center justify-between px-7 py-5' id='header'>
        <div id='logoContainer' className='text-center sm:text-left'>
          <h2 className="text-2xl font-bold text-white">Don't Get Mugged!</h2>
          <h4 className="text-md font-medium text-[#06BD60] uppercase mt-1">Training co.</h4>
        </div>
        <div className='flex flex-col gap-3 sm:flex-row items-center sm:items-center mt-5 sm:mt-0' id='buttonContainer'>
          <div className='mr-0 sm:mr-4 mb-3 sm:mb-0'>
            <ButtonFull buttonText='Login' navigationURL='/login' />
          </div>
          <div>
            <ButtonOutline buttonText='Register' navigationURL='/register' />
          </div>
        </div>
      </div>
      <div className='flex flex-col items-start bg-white p-5 sm:p-10 w-full max-w-screen-md sm:max-w-lg' id='messageContainer'>
        <h2 className='text-3xl uppercase font-black text-center sm:text-left'>Logout Successful.</h2>
        <h4 className='text-base mt-2 text-center sm:text-left'>You have successfully logged out, please login again</h4>
      </div>
    </div>
  );
}

export default LogoutPage;